import { render, staticRenderFns } from "./AdminShopUpdate.vue?vue&type=template&id=c8df0e20"
import script from "./AdminShopUpdate.vue?vue&type=script&lang=js"
export * from "./AdminShopUpdate.vue?vue&type=script&lang=js"
import style0 from "./AdminShopUpdate.vue?vue&type=style&index=0&id=c8df0e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports